import { Instagram, Twitter, Facebook, Youtube, Music, Music2, Globe } from "lucide-react";

/**
 * Centralized list of supported social media platforms.
 * Used in ProfilePage, ArtistProfilePage, UserProfilePage, and ProfileEditModal.
 *
 * - `key` matches the field stored in user.social_links / artist.social_links
 * - `placeholder` is shown in the input
 * - `url(value)` builds the public URL for the link
 */
export const SOCIAL_PLATFORMS = [
  {
    key: "instagram",
    label: "Instagram",
    icon: Instagram,
    placeholder: "@pseudo",
    url: (v) => v.startsWith("http") ? v : `https://instagram.com/${v.replace("@", "")}`,
  },
  {
    key: "facebook",
    label: "Facebook",
    icon: Facebook,
    placeholder: "@page ou URL complete",
    url: (v) => v.startsWith("http") ? v : `https://facebook.com/${v.replace("@", "")}`,
  },
  {
    key: "twitter",
    label: "Twitter / X",
    icon: Twitter,
    placeholder: "@pseudo",
    url: (v) => v.startsWith("http") ? v : `https://x.com/${v.replace("@", "")}`,
  },
  {
    key: "tiktok",
    label: "TikTok",
    icon: Music2,
    placeholder: "@pseudo",
    url: (v) => v.startsWith("http") ? v : `https://tiktok.com/@${v.replace("@", "")}`,
  },
  {
    key: "youtube",
    label: "YouTube",
    icon: Youtube,
    placeholder: "@chaine ou lien",
    url: (v) => v.startsWith("http") ? v : `https://youtube.com/${v.startsWith("@") ? v : "@" + v}`,
  },
  {
    key: "spotify",
    label: "Spotify",
    icon: Music,
    placeholder: "Lien artiste Spotify",
    url: (v) => v.startsWith("http") ? v : `https://open.spotify.com/artist/${v}`,
  },
  {
    key: "soundcloud",
    label: "SoundCloud",
    icon: Music,
    placeholder: "@pseudo ou lien",
    url: (v) => v.startsWith("http") ? v : `https://soundcloud.com/${v.replace("@", "")}`,
  },
  {
    key: "apple_music",
    label: "Apple Music",
    icon: Music,
    placeholder: "Lien artiste Apple Music",
    url: (v) => v.startsWith("http") ? v : `https://music.apple.com/artist/${v}`,
  },
  {
    key: "deezer",
    label: "Deezer",
    icon: Music,
    placeholder: "Lien artiste Deezer",
    url: (v) => v.startsWith("http") ? v : `https://www.deezer.com/artist/${v}`,
  },
  {
    key: "bandcamp",
    label: "Bandcamp",
    icon: Music,
    placeholder: "@pseudo.bandcamp.com",
    url: (v) => v.startsWith("http") ? v : `https://${v.replace("@", "")}.bandcamp.com`,
  },
  {
    key: "website",
    label: "Site web",
    icon: Globe,
    placeholder: "https://...",
    url: (v) => v.startsWith("http") ? v : `https://${v}`,
  },
];
